import css from "styled-jsx/css";

export default css`
  @media screen and (min-width: 1024px) {
    .faker-my-products {
      display: flex;
      justify-content: space-between;
      .products {
        width: 57%;
      }
      .banners {
        width: 35%;
      }
    }
  }
`;
